import React from 'react';

interface PlanCardProps {
  plan: {
    id: string;
    name: string;
    description: string;
    price: number;
    period: string;
    features: string[];
    isPopular?: boolean;
  };
  onClick: (id: string) => void;
  buttonText: string;
  disabled?: boolean;
}

// Create a completely new component with a different name
const SubscriptionPlanCard: React.FC<PlanCardProps> = ({ 
  plan, 
  onClick, 
  buttonText,
  disabled = false
}) => {
  return (
    <div className={`bg-white p-6 rounded-lg shadow-md border ${plan.isPopular ? 'border-primary-400 ring-2 ring-primary-50' : 'border-neutral-200'}`}>
      {plan.isPopular && (
        <div className="bg-primary-500 text-white text-xs font-bold uppercase py-1 px-2 rounded-full inline-block mb-2">
          Most Popular
        </div>
      )}
      <h3 className="text-xl font-serif font-bold mb-2">{plan.name}</h3>
      <p className="text-neutral-600 text-sm mb-4">{plan.description}</p>
      <div className="text-2xl font-bold mb-4">
        ₹{plan.price}
        <span className="text-sm font-normal text-neutral-500">/{plan.period}</span>
      </div>
      <ul className="mb-6 space-y-2">
        {plan.features.map((feature: string, index: number) => (
          <li key={index} className="flex items-start text-sm">
            <span className="text-green-500 mr-2">✓</span>
            <span>{feature}</span>
          </li>
        ))}
      </ul>
      <button
        onClick={() => onClick(plan.id)}
        disabled={disabled}
        className={`w-full py-2 px-4 rounded-md transition-colors ${
          disabled
            ? 'bg-neutral-300 text-neutral-500 cursor-not-allowed'
            : 'bg-primary-500 text-white hover:bg-primary-600'
        }`}
      >
        {buttonText}
      </button>
    </div>
  );
};

// Export the new component
export default SubscriptionPlanCard;

// Keep the old export for backward compatibility
export const PlanCard: React.FC<PlanCardProps> = SubscriptionPlanCard;